import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { pushApi } from '../api/push.api';

const scheduledPromotionsQueryKey = ['push', 'scheduled-promotions'] as const;
export const promotionHistoryQueryKey = ['push', 'promotion-history'] as const;

export function useScheduledPromotions() {
    return useQuery({
        queryKey: scheduledPromotionsQueryKey,
        queryFn: () => pushApi.getScheduledPromotions(),
        refetchInterval: 30_000,
    });
}

export function usePromotionHistory() {
    return useQuery({
        queryKey: promotionHistoryQueryKey,
        queryFn: () => pushApi.getPromotionHistory(),
        refetchInterval: 15_000,
    });
}

export function useCancelScheduledPromotion() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => pushApi.cancelScheduledPromotion(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: scheduledPromotionsQueryKey });
            queryClient.invalidateQueries({ queryKey: promotionHistoryQueryKey });
            notifications.show({
                title: 'Готово',
                message: 'Запланированная рассылка отменена.',
                color: 'green',
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: 'Ошибка',
                message: error?.response?.data?.message || 'Не удалось отменить рассылку',
                color: 'red',
            });
        },
    });
}
